import { useEffect, useState, useRef } from "react";
import styles from "./index.module.scss";
import { getCall, postCall, putCall } from "../../services/apiService";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Loader from "../../common/components/Loader";
import RegistrationHeader from "../../components/registration/RegistrationHeader";
import { Button } from "../../common/components/Button";
import { endPoints, PhoneErrorMessages, phoneNumberType } from "../../constants/urlConstants";
import {
  getItemInLocalStorage,
  setItemInLocalStorage,
} from "../../services/localStorage";
import useRazorpay from "../../components/RazorPayments";
import {
  APPROVED,
  COMPLETED,
  FORM,
  INDIA,
  OFFLINE_PENDING,
  ON_HOLD,
  ONLINE_COMPLETED,
  ONLINE_PENDING,
  PENDING,
  PENDING_APPROVAL,
  REJECTED,
  REQUESTED,
  SAVE_DRAFT,
  SECTION_KEYS,
  STATUS,
  SUCCESS,
  WARNING,
  WARNING_MESSAGES,
} from "../../constants";
import AwaitingApprovalScreen from "../../components/registration/AwaitingApprovalScreen";
import {
  getApprovalStatus,
  getCurrentSection,
  getFormStatus,
  getInputValues,
  GroupedQuestion,
  handleAWSFileUpload,
  useRegistrationData,
  validateCurrentSection,
  getAllocatedProgramData,
  getSuccessStatus,
  triggerWebhook,
  getAllocatedProgamPrice,
  stringToNumber,
  validateField,
  getRegistrationStatus,
  isDependentCleared,
} from "../../utils/registrationUtils";
import RegistrationSuccess from "../../components/registration/RegistrationSuccess";
import RenderField from "../../common/components/RenderFields";
import Breadcrumb from "../../common/components/Breadcrumb";
import { calculateAge, formateDate } from "../../utils/commonFunctions";
import { Avatar } from "@mui/material";
import PaymentCard from "../../components/registration/PaymentCard";
import Footer from "../../common/components/Footer";
import GrayLine from "../../common/components/GrayLine";
import dropdownIcon from "../../assets/images/expandIcon.svg";
import { notify } from "../../common/components/ToastMessage/index.tsx";
import { logout as logoutApi } from "../../services/nativeAuth";
import AlertPopup from "../../common/components/AlertPopup/index.tsx";
import parsePhoneNumberFromString from "libphonenumber-js";
export interface Program {
  id: number;
  programId: number;
  name: string;
  code: string;
  description: string;
  startDate: string;
  endDate: string;
  basePrice: string;
  currency: string;
  status: string;
  availableSeats: number;
  duration: string;
  type: {
    id: number;
    name: string;
  };
  sgst?: string;
  cgst?: string;
  igst?: string;
  gstNumber?: string;
}

export interface mahatriaChoiceConfig {
  allowMahatriaChoice: boolean;
  mahatriaChoicetText: string;
}
export interface Question {
  id: number;
  label: string;
  type: string;
  bindingKey: string;
  config: {
    isDisable?: boolean;
    isDefaultValue?: boolean;
    allowMahatriaChoice?: boolean;
    minYears?: number;
    maxYears?: number;
    isRequired?: boolean;
    minCharacter?: number;
    maxCharacters?: number;
    futureDateValidation?: string;
    pastDateValidation?: string;
    mahatriaChoiceConfig?: mahatriaChoiceConfig;
    minValue?: number;
    maxValue?: number;
    validationPattern?: string;
    apiUrl?: string; // For API calls
    category?: string;
    conditionalFields?: number[];
    startDate?: string | null;
    endDate?: string | null;
    allowedDigits?: number;
    helperText?: string;
    prefill?: {
      prefillFrom?: number;
      prefillIf?: {
        questionId: number;
        value: string | number | boolean;
      }[];
      prefillType?: string;
      prefillValue?: string;
    };
    dateTypeValidation?: "static" | "dynamic" | "custom";
    dateValidationType?: "static" | "dynamic";
    futureValidation?: DateValidation;
    pastValidation?: DateValidation;
    patternErrorMsg?: string;
    showDialogMessage:
      | {
          type: string;
          isShow: boolean | string;
          imageName: string | null;
          contentType: string | null;
          dialogueContent: string | null;
        }[]
      | null;
    showDialog?: {
      type: string;
      isShow: boolean | string;
      imageName: string | null;
      contentType: string | null;
      dialogueContent: string | null;
    } | null;
    dependsOn?: {
      questionId: number;
      operator?: string;
      value: string | number | boolean;
      questionBindingKey: string;
      transformedMinValue?: number;
      transformedMaxValue?:number;
      type?: string;
    }[];
  };
  formSection: {
    id: number;
    name: string;
    description: string;
  };
  questionOptionMaps: Array<{
    option: {
      id: number;
      name: string;
    };
  }>;
}
export interface Section {
  id: number;
  name: string;
  description: string;
  displayOrder: number;
  key: string;
}

export interface ProgramQuestionMap {
  id: number;
  question: Question;
  registrationLevel: string;
  displayOrder: number;
  programQuestionFormSection: Section;
}

export interface ProgramDetails {
  id: number;
  name: string;
  code: string;
  bannerImageUrl?: string;
  description: string;
  basePrice: string;
  currency: string;
  requiresApproval: boolean | null;
  duration: string;
  startDate: string;
  checkinAt: string;
  checkoutAt: string;
  checkinEndsAt: string;
  modeOfOperation: string;
  limitedSeats: boolean;
  startsAt?: string;
  endsAt?: string;
  involvesTravel?: boolean;
  noOfSession?: number;
  isGroupedProgram: boolean;
  registrationStartsAt: string;
  bannerAnimationUrl?: string;
  meta: {
    price: { [key: string]: number };
  };
  type: {
    maxSessionDurationDays: number;
    requiresApproval: boolean;
    requiresPayment: boolean;
    involvesTravel: boolean;
    name: string;
    waitlistApplicable: boolean;
    venue: string;
    meta: {
      price: any;
    };
    isGroupedProgram?: boolean;
    key?: string;
  };
  statusMessage?: { message: string[]; state: string };
  registrationId?: string | null;
  blessesProgram?: Program | null;
  sessions: Program[];
  programQuestionMaps: ProgramQuestionMap[];
  groupedPrograms: Program[];
  gstNumber?: string;
  registrationWindowStatus: string;
  cgst?: string;
  sgst?: string;
  igst?: string;
}

export interface DateValidation {
  unit: "year" | "months" | "days";
  enabled: boolean;
  maxValue?: number | null;
  minValue?: number | null;
  dateValidationField?: string | null;
}
export interface FormResponse {
  [key: string]: any;
}

const DynamicForm = () => {
  const [onwardFile, setOnwardFile] = useState<File | null>(null);
  const [returnFile, setReturnFile] = useState<File | null>(null);
  const [isMobile, setIsMobile] = useState(false);
  const [isExtraSmall, setIsExtraSmall] = useState(false); 
  // Check if screen is mobile size
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1029);
      setIsExtraSmall(window.innerWidth < 468);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);
  const [submitted, setSubmitted] = useState(false);

  const [currentStep, setCurrentStep] = useState<
    | "form"
    | "success"
    | "waitlisted"
    | "pending_approval"
    | "rejected"
    | "on_hold"
  >("form");
  const [searchParams, setSearchParams] = useSearchParams();
  const keys = Array.from(searchParams.keys());
  const userIdParam = searchParams.get("userId");
  const isSuccessFlag = searchParams.get("isSuccess") === "true";
  const isEditFlag = searchParams.get("isEdit") === "true";
  const editPayment = searchParams.get("editpayment");
  const seekerDetails = getItemInLocalStorage("seekerDetails") || {};
   const [registrationCountryCode, setRegistrationCountryCode] = useState<string>();
  const programId = searchParams.get("programId");
  const prefillClearedRef = useRef<boolean>(false);
  const {
    loading,
    apiError,
    programDetails,
    groupedAnswersData,
    userStatus,
    groupedQuestions,
    bindingKeyHashMap,
    QuestionIdHashMap,
    registrationData,
    refetch,
  } = useRegistrationData(programId || "", seekerDetails.id);
  // const [programDetails, setProgramDetails] = useState<ProgramDetails | null>(
  // null,
  // );
  const [handleLoader, setLoading] = useState(false);
  const [formData, setFormData] = useState<{ [key: number]: GroupedQuestion }>(
    groupedAnswersData || {},
  );
  const [saveFormData, setSaveFormData] = useState<{ [key: number]: GroupedQuestion }>(
    groupedAnswersData || {},
  );
  const [currentSectionIndex, setCurrentSectionIndex] = useState(1);
  const [completedSections, setCompletedSections] = useState<Set<number>>(
    new Set(),
  );
  const [errors, setErrors] = useState<{
    [key: string]:
      | { message: string; displayOrder: number; sectionOrder?: number }
      | undefined;
  }>({});
  const [editMode, setEditMode] = useState(false);
  const [showSuccess, setshowSuccess] = useState(false);
  const [showAdditionalInfo, setShowAdditionalInfo] = useState(false);
  const [editRegistration, setEditRegistration] = useState(false);
  const [alert, setAlert] = useState<{
    open: boolean;
    message: string[];
    type: string;
    onConfirm?: () => void;
    onCancel?: () => void;
    confirmText?: string;
    cancelText?: string;
    onReupload?: () => void;
  }>({ open: false, message: [], type: "" });
  const [sectionLoader, setSectionLoader] = useState(false);

  const [basePrice, setBasePrice] = useState<number | null>(null);
  const { initiatePayment, isScriptLoaded } = useRazorpay();
  const [localGroupedQuestions, setLocalGroupedQuestions] = useState<any>(null);
  const navigate = useNavigate();
  const [showBillingAmount, setShowBillingAmount] = useState(false);
  const paymentCardRef = useRef<HTMLDivElement | null>(null);
  const [isPaymentCardVisible, setIsPaymentCardVisible] = useState(false);
  const [userAllocatedProgram, setAllocatedProgram] = useState<Program | null>(
    null,
  );
  const [isShowContent, setisShowContent] = useState(false);
  const [fieldChange, setFieldChange] = useState(false);
    const [isSubmit, setIsSubmit] = useState<boolean>(false);
  
  const fieldRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});
  const trimFormValue = (value: string): string => {
    return typeof value === "string" ? value.trimEnd() : value;
  };
  const [phoneNumberSend, setPhoneNumberSend] = useState<string>("");
  const errorRef = useRef<boolean>(false);
  useEffect(() => {
    if (apiError != null && !errorRef.current)
      notify(apiError[0], apiError[1], WARNING);
    errorRef.current = true; // Reset errorRef after displaying the error
  }, [apiError]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // PaymentCard is visible if any part of it is in viewport
        setIsPaymentCardVisible(entry.isIntersecting);
      },
      {
        threshold: 0.1, // Trigger when 10% of the element is visible
        rootMargin: "0px 0px -50px 0px", // Optional: adjust detection area
      },
    );

    if (paymentCardRef.current) {
      observer.observe(paymentCardRef.current);
    }

    return () => {
      if (paymentCardRef.current) {
        observer.unobserve(paymentCardRef.current);
      }
    };
  }, [currentSectionIndex]); // Re-run when section changes

  const handleShowBillingPopUp = () => {
    setShowBillingAmount(!showBillingAmount);

    // Scroll to PaymentCard component
    if (paymentCardRef.current) {
      paymentCardRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };
  const location = useLocation();
  const sectionId = location?.state?.sectionId || null;
  useEffect(() => {
    if (userStatus != null) {
      const status = getCurrentSection(
        setCurrentSectionIndex,
        userStatus,
        editRegistration,
        showAdditionalInfo,
        showSuccess,
      );
      setCurrentStep(status);
      if (
        status == FORM &&
        (programDetails?.registrationWindowStatus === STATUS.CLOSED ||
          programDetails?.registrationWindowStatus === STATUS.NOT_OPENED)
      ) {
        setAlert({
          open: true,
          message:
            programDetails?.registrationWindowStatus === STATUS.CLOSED
              ? WARNING_MESSAGES.REGIISTRATION_CLOSED
              : WARNING_MESSAGES.REGIISTRATION_NOT_OPENED,
          type: WARNING,
          confirmText: "okay",
          onConfirm: () => {
            navigate("/myspace/programs", { replace: true });
          },
        });
      }
      setAllocatedProgram(getAllocatedProgramData(userStatus) || null);
    } 
    if(programDetails?.registrationWindowStatus === STATUS.CLOSED || programDetails?.registrationWindowStatus === STATUS.NOT_OPENED){ 
      setAlert({
          open: true,
          message: programDetails?.registrationWindowStatus === STATUS.CLOSED ? WARNING_MESSAGES.REGIISTRATION_CLOSED : WARNING_MESSAGES.REGIISTRATION_NOT_OPENED,
          type: WARNING,
          confirmText: "okay",
          onConfirm: () => {
            navigate("/myspace/programs", { replace: true });
          },
        })
    }
  }, [
    userStatus,
    showSuccess,
    currentStep,
    showAdditionalInfo,
    programDetails,
  ]);
  // useEffect(() => {
  //   if (groupedAnswersData) {
  //     setFormData(groupedAnswersData);
  //     if(keys) {
  //     keys.map((key) =>
  //       {
  //         console.log("key", key);
  //         if(key != "isSuccess" && key != "isEdit" && key != "programId" && key != "userId") {
  //           const questionId = bindingKeyHashMap ? bindingKeyHashMap[key] : undefined;
  //           if (questionId !== undefined) {
  //             handleFieldChange(questionId, searchParams.get(JSON.parse(JSON.stringify(key))) || "");
  //           }
  //         }
  //         if(key == "userId" && userIdParam != seekerDetails.id) {
  //           alert("You are not authorized to edit this registration.");
  //           navigate("/myspace/programs", { replace: true });
  //         }
  //       })
  //   }
  //   }
  // }, [groupedAnswersData]);
  const prefillDoneRef = useRef<string | boolean>(true);
  useEffect(() => {
    if (
      groupedAnswersData &&
      (prefillDoneRef.current == true || prefillDoneRef.current == "updated")
    ) {
      setFormData(groupedAnswersData);
      setSaveFormData(groupedAnswersData)
      if (keys) {
        keys.forEach((key) => {
          if (
            key !== "isSuccess" &&
            key !== "isEdit" &&
            key !== "programId" &&
            key !== "userId"
          ) {
            const questionId = bindingKeyHashMap
              ? bindingKeyHashMap[key]
              : undefined;
            if (questionId !== undefined) {
              const question = programDetails?.programQuestionMaps.filter(item=> {
              return item.question.id == questionId
            })
              handleFieldChange(questionId, searchParams.get(key) || "", question[0].question);
               if((userStatus?.paymentDetails[0] &&
                (userStatus?.paymentDetails[0].paymentStatus == OFFLINE_PENDING || 
                userStatus?.paymentDetails[0].paymentStatus == ONLINE_COMPLETED ||
                userStatus?.paymentDetails[0].paymentStatus.includes(COMPLETED))) &&
                !keys.includes("isSuccess")) {
                searchParams.set("isSuccess", "true");
                setSearchParams(searchParams);
              }
            }
          }
        });
      }
      if (prefillDoneRef.current == "updated") {
        prefillDoneRef.current = false;
      } else {
        prefillDoneRef.current = "updated"; // Prevent future runs
      }

      if (userIdParam != null && userIdParam != seekerDetails.id) {
        setAlert({
              open: true,
              message: WARNING_MESSAGES.NOT_AUTHORIZED,
              type: WARNING,
              confirmText: "logout",
              onConfirm: async () => {
                try{
                  await logoutApi();
                } catch (e){
                }
                localStorage.clear();
                sessionStorage.clear();
                setAlert({ message: [], open: false, type: "" });
                navigate("/", { replace: true });
              },
              // cancelText: "cancel",
            });
      } else if(isEditFlag){
          handleEditRegistration();
      }
    }
    // Only depend on groupedAnswersData, keys, etc. NOT formData!
  }, [groupedAnswersData, keys, bindingKeyHashMap]);

  useEffect(() => {
    if (groupedQuestions && localGroupedQuestions == null) {
      setLocalGroupedQuestions(JSON.parse(JSON.stringify(groupedQuestions)));
    }
  }, [groupedQuestions]);

  useEffect(() => {
    if (userStatus && !prefillClearedRef.current) {
      if (sectionId == 1 || isEditFlag) {
        handleEditRegistration();
      } else if (sectionId == 2) {
        handleEditPayment();
      } else if (sectionId == 3) {
        setshowSuccess(false);
        handleEditData();
      }
      prefillClearedRef.current = true;
    }
  }, [userStatus]);

  const handleFieldChange = async (questionId: number, value: any, question: Question ) => {
    if((question.bindingKey == "countryName" && value?.toString().toLowerCase() != INDIA ) || (question.bindingKey == "phoneNumberType")
  ) {
      setEditMode(true);
    }
    const allQuestionsInCurrentSection = groupedQuestions[currentSectionIndex] || []
      let valueDefault: string = "";
  if (allQuestionsInCurrentSection) {
    const invoiceNameQuestion = allQuestionsInCurrentSection.questions.find(item => 
       item.question?.config?.prefill?.prefillIf && item.question?.config?.prefill?.prefillIf?.length > 0
    );
    
    if (invoiceNameQuestion && invoiceNameQuestion.question.config?.prefill?.prefillIf) {
      const prefillValues = invoiceNameQuestion.question.config.prefill.prefillIf.map(prefillItem => 
        prefillItem.value
      );
      // Get the first value as a string
      valueDefault = prefillValues?.[0] ?? "";
    }
  }
    if(question.bindingKey === "isGstRegistered" && value === question?.config?.showDialog?.isShow )
    {
       setisShowContent(true); 
    }
    if (
      question.bindingKey === "existingProformaInvoice" &&
      valueDefault !== "no"
    ) {
      console.log("The queston inside is ", question);
      setFieldChange(true);
    } else {
      setFieldChange(false);
    }
    const currentValue = formData?.[currentSectionIndex]?.[questionId];
    if (currentValue === value) {
      return; // No state change needed -- Infinite Loop Fix
    }
    if (formData && userStatus && formData[1]) {
      const result = getAllocatedProgamPrice(userStatus);
      const price = result?.price;
      const program = result?.program;
      const { finalValue, inputValues } = getInputValues(
        program,
        formData[currentSectionIndex] || {},
        true,
        bindingKeyHashMap,
      );
      if (price) {
        setBasePrice(finalValue?.value);
      }
    }
    if (
      bindingKeyHashMap &&
      question?.bindingKey === "paymentMode" &&
      value !== "Online (Through Razorpay)"
    ) {
      // If the question is "Payment Mode", set the base price based on the selected payment mode
      const basePrice = getAllocatedProgamPrice(userStatus);
      if (basePrice) {
        setFormData((prev = {}) => ({
          ...prev,
          [currentSectionIndex]: {
            ...(prev && prev[currentSectionIndex]
              ? prev[currentSectionIndex]
              : {}),
            [questionId]: value,
            [bindingKeyHashMap["originalPayment"]]: basePrice.toString(), // Set the base price in the form data
          },
        }));
        return;
      }
    }

    const isFileTypeQuestion = question?.type === "file";

    if (isFileTypeQuestion) {
      if (!value || value.length === 0) {
        setFormData((prev = {}) => ({
          ...prev,
          [currentSectionIndex]: {
            ...(prev && prev[currentSectionIndex]
              ? prev[currentSectionIndex]
              : {}),
            [questionId]: "",
          },
        }));
        return;
      } else {
        const bindingKey = question?.bindingKey;
        setSectionLoader(true);
        await handleAWSFileUpload(value).then((fileUrl) => {
          if (
            bindingKey === "pictureUrl" ||
            bindingKey === "uploadOnwardJourneyTicket" ||
            bindingKey === "uploadReturnJourneyTicket"
          ) {
            setSectionLoader(true);
            return postCall(
              endPoints.extractData,
              {
                url: fileUrl,
                type:
                  bindingKey === "pictureUrl"
                    ? "identity_document"
                    : "flight_ticket",
              },
              false,
            )
              .then((response: any) => {
                setSectionLoader(false);
                if (bindingKey === "pictureUrl") {
                  if (!response?.data?.data?.data?.data) {
                    notify(
                      WARNING_MESSAGES.FAILED_TO_EXTRACT[0],
                      WARNING_MESSAGES.FAILED_TO_EXTRACT[1],
                      WARNING,
                    );
                    return;
                  }
                } else {
                  if (!response?.data?.data?.data?.segments) {
                    notify(
                      WARNING_MESSAGES.FAILED_TO_EXTRACT[0],
                      WARNING_MESSAGES.FAILED_TO_EXTRACT[1],
                      WARNING,
                    );
                    return;
                  }
                }

                if (
                  bindingKey === "uploadOnwardJourneyTicket" ||
                  bindingKey === "uploadReturnJourneyTicket"
                ) {
                  prefillFormFromExtractedDetails(
                    response,
                    currentSectionIndex,
                    programDetails?.programQuestionMaps,
                  );
                } else {
                  // Map travelInfoNumber to the correct field if present
                  const travelInfoNumber =
                    response?.data?.data?.data?.data?.travelInfoNumber;
                  if (travelInfoNumber) {
                    // Find the question with bindingKey === 'travelInfoNumber' in the current section
                    const currentSection = Object.values(groupedQuestions)[
                      currentSectionIndex - 1
                    ] as any;
                    if (currentSection && currentSection.questions) {
                      const match = currentSection.questions.find(
                        (pqm: any) =>
                          pqm.question &&
                          pqm.question.bindingKey === "travelInfoNumber",
                      );
                      if (match) {
                        setFormData((prev = {}) => ({
                          ...prev,
                          [currentSectionIndex]: {
                            ...(prev && prev[currentSectionIndex]
                              ? prev[currentSectionIndex]
                              : {}),
                            [match.question.id]: travelInfoNumber,
                          },
                        }));
                      }
                    }
                  }
                }
                // Set the uploaded file URL for the field
                setFormData((prev = {}) => ({
                  ...prev,
                  [currentSectionIndex]: {
                    ...(prev && prev[currentSectionIndex]
                      ? prev[currentSectionIndex]
                      : {}),
                    [questionId]: fileUrl?.toString() || "",
                  },
                }));
              })
              .catch((err: any) => {
                setSectionLoader(false);
                console.error(
                  "Failed to extract details from the document.",
                  err,
                );
                notify(
                  WARNING_MESSAGES.FAILED_TO_EXTRACT[0],
                  WARNING_MESSAGES.FAILED_TO_EXTRACT[1],
                  WARNING,
                );
                // alert("Failed to extract details from the document.");
              });
          } else {
            setFormData((prev = {}) => ({
              ...prev,
              [currentSectionIndex]: {
                ...(prev && prev[currentSectionIndex]
                  ? prev[currentSectionIndex]
                  : {}),
                [questionId]: fileUrl?.toString() || "",
              },
            }));
          }
          setSectionLoader(false);
        });
      }
    } else {
      setFormData((prev = {}) => ({
        ...prev,
        [currentSectionIndex]: {
          ...(prev && prev[currentSectionIndex]
            ? prev[currentSectionIndex]
            : {}),
          [questionId]: value,
        },
      }));
    }

    // Clear error for this field
    if (errors[questionId]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[questionId];
        return newErrors;
      });
    }
  };

  const showAlert = (
    show: boolean,
    message: string[],
    type: string,
    onReupload?: () => void,
  ) => {
    if (show) {
      setAlert({
        open: true,
        message: message,
        type: type,
        cancelText: "cancel",
        confirmText: onReupload ? "re-upload" : "okay",
        onReupload: onReupload,
      });
    }
  };
  const handleFieldBlur = async (question: Question, value: string , displayOrder : number , programQuestionFormSection:any) => {
  const error = await validateField(
    question,
    value,
    formData[currentSectionIndex],
    currentSectionIndex,
    userAllocatedProgram,
    bindingKeyHashMap,
  );
  if (
    error?.includes("GST number does not match the state for the given pincode")
  ) {
    if (question.bindingKey == "gstNumber") {
      setErrors((prev) => ({
        ...prev,
        "1055": error
          ? {
              message: error,
              displayOrder: displayOrder ?? 0,
              sectionOrder: programQuestionFormSection?.displayOrder ?? 0,
            }
          : undefined,
      }));
    } else if (
      question.bindingKey == "proFormaGstNumber" ||
      question.bindingKey == "proFormaZip"
    ) {
      setErrors((prev) => ({
        ...prev,
        "1204": error
          ? {
              message: error,
              displayOrder: displayOrder ?? 0,
              sectionOrder: programQuestionFormSection?.displayOrder ?? 0,
            }
          : undefined,
      }));
    }
  } else {
    setErrors((prev) => ({
      ...prev,
      [question.id]: error
        ? {
            message: error,
            displayOrder: displayOrder ?? 0,
            sectionOrder: programQuestionFormSection?.displayOrder ?? 0,
          }
        : undefined,
    }));
  }
  if (question.bindingKey == "zip" && !error) {
    setErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors["1055"];
      return newErrors;
    });
  } else if (question.bindingKey == "proFormaZip" && !error) {
    setErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors["1204"];
      return newErrors;
    });
  }
};

  const handlesubmitFormData = async (
    currentSectionIndex: number,
    isDraft: boolean = false,
  ) => {
  
    let formattedData = Object.entries(formData[currentSectionIndex])
    .filter(([key, value]) => {
      // Remove mobile number question if value length < 4
      if (
        bindingKeyHashMap && 
        Number(key) === bindingKeyHashMap["mobileNumber"] && 
        value && 
        value === registrationCountryCode
        ) {
        return false; // Exclude this question
      }
      return true; // Keep all other questions
    })
    .map(([key, value]) => ({
      questionId: Number(key),
      answer: (() => {
        if (typeof value === "string" && /^[\[{]/.test(value.trim())) {
          JSON.parse(value);
          return value.trimEnd();
        }
        return value?.toString().trimEnd();
      })(),
      bindingKey: QuestionIdHashMap?.[Number(key)] || "",
    }));
    formattedData = formattedData.filter(
      (item) =>
        item.answer !== undefined && item.answer !== null && item.answer !== "" || (item.bindingKey && programDetails?.programQuestionMaps.some(pqm => 
      pqm.question.bindingKey === item.bindingKey && 
      Array.isArray(pqm.question?.config?.dependsOn) && pqm.question.config.dependsOn.length > 0
    )));
    if (currentSectionIndex == 1 && !userStatus) {
      let payload = {
        programId: programDetails?.id,
        // programSessionId: 23,
        isSelfRegister: true,
        updateUserProfileData: true,
        answers: formattedData,
        createdBy: seekerDetails?.id || 0,
        updatedBy: seekerDetails?.id || 0,
        countryCode: `+${registrationCountryCode}`,
      };
      if (isDraft) {
        payload = {
          ...payload,
          registrationStatus: "save_as_draft",
          updateUserProfileData: false,
        };
      }
      const status = await postCall(
        endPoints.programRegistration,
        payload,
        false,
      )
        .then((response) => {
          if (
            response?.data?.statusCode === 200 ||
            response?.data?.statusCode === 201
          ) {
            setEditMode(false);
            return response.data.data;
          } else {
            if(response?.data.message.includes("Phone number") || response?.data?.message.includes("Email")) {
              return response?.data?.message;
            }
            else{
            return {};
            }
        }
        })
        .catch((error) => {
          return {};
        });
      return status;
    } else if (currentSectionIndex == 3) {
      console.log("is Draft payload", formData, currentSectionIndex, isDraft);
      let payload = {
        programRegistrationId: userStatus?.id
          ? Number(userStatus.id)
          : undefined,
        programId: programDetails?.id,
        formSectionId: currentSectionIndex,
        updateUserProfileData: false,
        // programSessionId: 23,
        isSelfRegister: true,
        answers: formattedData,
      };
      if (isDraft) {
        payload = {
          ...payload,
          registrationStatus: "save_as_draft",
        };
      }
      console.log("draft payload", payload);
      const status = await putCall(
        endPoints.programRegistration,
        payload,
        false,
      )
        .then((response) => {
          if (
            response?.data?.statusCode === 200 ||
            response?.data?.statusCode === 201
          ) {
            setEditMode(false);
            return response.data.data;
          } else {
            return {};
          }
        })
        .catch((error) => {
          return {};
        });
      return status;
    } else {
      console.log("is draft not");
      let payload = {
        programRegistrationId: Number(userStatus?.id),
        programId: programDetails?.id,
        formSectionId: currentSectionIndex,
        updateUserProfileData: currentSectionIndex === 1 ? true : false,
        // programSessionId: 23,
        isSelfRegister: true,
        answers: formattedData,
        countryCode: currentSectionIndex === 1 && `+${registrationCountryCode}`,
      };
      if (isDraft) {
        payload = {
          ...payload,
          registrationStatus: "save_as_draft",
        };
      }
      const status = await putCall(
        endPoints.programRegistration,
        payload,
        false,
      )
        .then((response) => {
          if (
            response?.data?.statusCode === 200 ||
            response?.data?.statusCode === 201
          ) {
            setEditMode(false);
            return response.data.data;
          } else {
            if(response?.data?.message?.includes("Phone number") || response?.data?.message?.includes("Email")) {
              return response?.data?.message;
            }
            else{
            return {};
            }
        }
        })
        .catch((error) => {
          console.error("Error submitting form data:", error);
          return {};
        });
      return status;
    }
  };

  const handleNextSession = async (currentSection: any) => {
    console.log(
      formData,
      "CurrentSECTION123",
      currentSection.section.name,
      programDetails?.type.requiresPayment,
      programDetails,
    );
    if (currentSection.section.key == SECTION_KEYS.PAYMENTSECTION && formData) {
      await handlePayment();
    } else {
      const newCompletedSections = new Set(completedSections);
      newCompletedSections.add(currentSectionIndex);
      setCompletedSections(newCompletedSections);
      const sections = Object.values(groupedQuestions);
      if (currentSectionIndex < sections.length - 1) {
        setCurrentSectionIndex(currentSectionIndex + 1);
      } else {
        setCurrentStep("success");
        searchParams.set("isSuccess", "true");
        setSearchParams(searchParams);
      }
      refetch();
    }
  };

useEffect(() => {
  if (submitted && Object.keys(errors).length > 0) {
    // Sort by sectionOrder, then by displayOrder
    const sortedErrorKeys = Object.keys(errors)
      .filter(
        (key) =>
          errors[key]?.displayOrder !== undefined &&
          errors[key]?.sectionOrder !== undefined
      )
      .sort((a, b) => {
        const sectionA = errors[a]?.sectionOrder ?? 0;
        const sectionB = errors[b]?.sectionOrder ?? 0;
        if (sectionA !== sectionB) return sectionA - sectionB;
        return (errors[a]?.displayOrder ?? 0) - (errors[b]?.displayOrder ?? 0);
      });
    const firstErrorKey = sortedErrorKeys[0];
    if (firstErrorKey && fieldRefs.current[firstErrorKey]) {
      fieldRefs.current[firstErrorKey]?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
      fieldRefs.current[firstErrorKey]?.focus?.();
    }
    setSubmitted(false);
  }
}, [errors, submitted]);

// Add this function inside your DynamicForm component
const cleanupEditPaymentParam = () => {
  if (searchParams.get("editpayment")) {
    searchParams.delete("editpayment");
    setSearchParams(searchParams);
  }
};

  const refreshSeekerDetails = async () => {
    try {
      const userId = seekerDetails?.id;
      if (!userId) return;
      const res = await getCall(`user/${userId}`, undefined, false);
      if (res?.data?.statusCode === 200 && res?.data?.data) {
        const data = res.data.data;
        setItemInLocalStorage("seekerDetails", data);
      } else {
        console.warn("Failed to refresh seeker details:", res?.data?.message);
      }
    } catch (e) {
      console.error("Failed to refresh seeker details:", e);
    }
  };

  const handleSectionComplete = async (currentSection: any) => {
    setIsSubmit(true);
    setLoading(true);
    const allocatedProgram = getAllocatedProgramData(userStatus);
    const isValid = await validateCurrentSection(
      currentSectionIndex,
      groupedQuestions,
      setErrors,
      formData,
      allocatedProgram,
      bindingKeyHashMap,
    );
    if (!isValid) {
      setLoading(false);
      setEditMode(true);
      setSubmitted(true);
      // setEditMode(true);
      return;
    }
    console.log("Allocated Program: handleSectionComplete", isValid, apiError);
    setLoading(true);
    setEditRegistration(false);
    setShowAdditionalInfo(false);
    if (currentSectionIndex == 2) {
      await handleNextSession(currentSection);
    } else {
      handlesubmitFormData(currentSectionIndex)
        .then(async (status) => {
          if(typeof status === 'string' && status.includes("Phone number"))
            {
              const ageCheck = calculateAge(formData[currentSectionIndex][bindingKeyHashMap.dob]);
              setLoading(false);
              let phnMessage = PhoneErrorMessages.normal;
              if(ageCheck !== "-"  && (ageCheck <= programDetails?.childMaxAge || ageCheck >= programDetails?.elderMinAge ) ){
                phnMessage = PhoneErrorMessages.restricted;
              }
              setLoading(false);
              setAlert({
                open: true,
                message: phnMessage,
                type: WARNING,
                confirmText: "okay",
                onConfirm: () => {},
              });
              return;
            }
            else if(typeof status === 'string' && status.includes("Email"))
            {
              setLoading(false);
              setAlert({
                open: true,
                message: status,
                type: WARNING,
                confirmText: "okay",
                onConfirm: () => {},
              });
              return;
            }
          if (Object.keys(status).length === 0) {
            
            setLoading(false);
            setAlert({
              open: true,
              message: WARNING_MESSAGES.API_ERROR,
              type: WARNING,
              confirmText: "okay",
              onConfirm: () => {},
            });
          
            return;
          } else {
            if (currentSectionIndex === 1) {
              await refreshSeekerDetails();
            }
            if (
              programDetails?.type.requiresApproval &&
              status?.registrationStatus === PENDING_APPROVAL
            ) {
              refetch();
              setCurrentStep(PENDING_APPROVAL);
            } else if (status?.registrationStatus == REJECTED) {
              refetch();
              setCurrentStep(REJECTED);
            } else if (status?.registrationStatus == ON_HOLD) {
              refetch();
              setCurrentStep(ON_HOLD);
            } else {
              console.log(
                "Allocated Program: next session",
                showAdditionalInfo,
                currentStep,
              );
              await handleNextSession(currentSection);
            }
            if (currentSectionIndex === 3) {
              setshowSuccess(true);
              setCurrentStep("success");
              searchParams.set("isSuccess", "true");
              setSearchParams(searchParams);
              refetch();
            }
            return;
          }
        })
        .catch((error) => {
          console.error("Error submitting form data:", error);
          setAlert({
            open: true,
            message: WARNING_MESSAGES.API_ERROR,
            type: WARNING,
            confirmText: "okay",
            // cancelText: "cancel",
            // onConfirm: () => handleSectionComplete(currentSection),
            onConfirm: () => {},
          });
          return;
        })
        .finally(() => {
          if (
            searchParams.get("isEdit") != "" &&
            searchParams.get("isEdit") != null &&
            searchParams.get("isEdit") != undefined
          ) {
            searchParams.delete("isEdit");
            setSearchParams(searchParams);
          }

          setLoading(false);
        });
    }
  };

  const handlePayment = async () => {
    const sectionQuestions =
      (Object.values(groupedQuestions)[currentSectionIndex - 1] as any)
        ?.questions || [];

    let formattedData = sectionQuestions
      .filter(
        (pqm: any) =>
          formData[currentSectionIndex] &&
          formData[currentSectionIndex][pqm.question.id] !== undefined &&
          formData[currentSectionIndex][pqm.question.id] != "",
      )
      .reduce((acc: any, pqm: any) => {
        const formKey = pqm.question.bindingKey;
        if (formKey == "tdsAmount") {
          acc[formKey] = stringToNumber(
            formData[currentSectionIndex][pqm.question.id],
          );
        } else {
          acc[formKey] = formData[currentSectionIndex][pqm.question.id];
        }
        return acc;
      }, {});
    if (!(formattedData["paymentMode"] == "Online (Through Razorpay)")) {
      formattedData = {
        ...formattedData,
        offlinePaymentMeta: {
          ...formattedData,
          paymentMethod: formattedData["paymentMode"],
        },
      };
      formattedData["paymentMode"] = "offline";
      formattedData.paymentMeta = {
        ...formattedData.paymentMeta,
        // paymentMode: formattedData["paymentMode"],
      };
    } else {
      formattedData = {
        ...formattedData,
      };
      formattedData["paymentMode"] = "online";
    }

    const registeredMeta = Object.entries(formData[currentSectionIndex]).map(
      ([key, value]) => ({
        questionId: Number(key),
        answer: value.toString(),
      }),
    );
    formattedData["paymentMeta"] = registeredMeta.filter(
      (item) =>
        item.answer !== undefined && item.answer !== null && item.answer !== "",
    );

    postCall(`payment/initiate/${userStatus?.id}`, formattedData, false)
      .then((response) => {
        if (
          response?.data?.statusCode >= 200 &&
          response?.data?.statusCode < 300
        ) {
          // Check if payment is already completed
          if (response?.data?.data?.isPaymentCompleted) {
            setAlert({
              open: true,
              message: WARNING_MESSAGES.PAYMENT_DONE,
              type: WARNING,
              confirmText: "okay",
              onConfirm: () => {
                navigate("/myspace/programs", { replace: true });
              },
            });
            setLoading(false);
            return;
          }

          // Handle online pending payment
          if (response.data?.data?.paymentStatus == ONLINE_PENDING) {
            const amount = response.data?.data?.amount;
            const orderId = response.data?.data?.razorpayOrderId;
            
            if (!amount || !orderId) {
              setLoading(false);
              setAlert({
                open: true,
                message: WARNING_MESSAGES.PAYMENT_ERROR,
                type: WARNING,
                confirmText: "okay",
                onConfirm: () => {},
              });
              return;
            }

            initiatePayment({
              amount: amount,
              orderId: orderId,
              keyId: process.env.REACT_APP_RAZORPAY_KEY_ID ?? "",
              name: "Premium Service",
              description: "Monthly subscription",
              prefill: {
                name : registrationData ? registrationData.fullName : "",
                email:  registrationData ? registrationData.emailAddress : "",
                contact: registrationData ? registrationData.mobileNumber : "",
              },
              theme: { color: "#10b981" },
              onSuccess: (response) => {
                setAlert({
                  open: false,
                  message: [],
                  type: "",
                });
                // alert("Payment successful!");
                triggerWebhook(response,"success");
                // setShowAdditionalInfo(true)
                setshowSuccess(true);
                setCurrentStep("success");
                searchParams.set("isSuccess", "true");
                cleanupEditPaymentParam();
                setSearchParams(searchParams);
                refetch();
              },
              onFailure: (error) => {
                console.log("Payment failed:", error);
                triggerWebhook(error,"failed");
                setAlert({
                  open: true,
                  message: WARNING_MESSAGES.PAYMENT_ERROR,
                  type: WARNING,
                  confirmText: "okay",
                  onConfirm: () =>{},
                });
                // alert("Payment failed: " + error?.description);
              },
              onDismiss: (response) => {
                setAlert({
                  open: false,
                  message: [],
                  type: ""
                });
                triggerWebhook(response,"dismiss");
                // alert("Payment dismissed");
                notify(
                  "Payment cancelled",
                  "You can try again anytime from your dashboard.",
                  WARNING,
                );
              },
            });
          } else {
            refetch();
            setCurrentStep("success");
            searchParams.set("isSuccess", "true");
            cleanupEditPaymentParam();
            setSearchParams(searchParams);
            // setShowAdditionalInfo(true)
            setshowSuccess(true);
            setLoading(false);
            return;
          }
        } else {
          setAlert({
            open: true,
            message: WARNING_MESSAGES.PAYMENT_ERROR,
            type: WARNING,
            confirmText: "okay",
            onConfirm: () => {},
          });
          // alert("Payment initialization failed: " + response?.data?.message);
        }
        // setCurrentStep("success");
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error initializing payment:", error);
        setLoading(false);
        setAlert({
          open: true,
          message: WARNING_MESSAGES.PAYMENT_ERROR,
          type: WARNING,
          confirmText: "okay",
          onConfirm: () => {},
        });
        // alert("Error initializing payment: " + error.message);
      })
      // .finally(() => {
      //   if (
      //     searchParams.get("editpayment") != "" &&
      //     searchParams.get("editpayment") != null &&
      //     searchParams.get("editpayment") != undefined
      //   ) {
      //     searchParams.delete("editpayment");
      //     setSearchParams(searchParams);
      //   }
      // });
  };

  const handleEdit = () => {
    setEditMode((prev) => !prev);
  };

  const handlePreviousSection = () => {
    // if (window.history.length > 1) {
    //   navigate(-1);
    // } else {
    navigate("/myspace/programs", { replace: true });
    // }
  };

  const handleDraft = () => {
    setLoading(true);
    handlesubmitFormData(currentSectionIndex, true)
      .then(async (status) => {
        if (Object.keys(status).length != 0) {
          if(typeof status === 'string' && status.includes("Phone number"))
          {
            const ageCheck = calculateAge(formData[currentSectionIndex][bindingKeyHashMap.dob]);
            setLoading(false);
            let phnMessage = PhoneErrorMessages.normal;
            if(ageCheck !== "-"  && (ageCheck <= programDetails?.childMaxAge || ageCheck >= programDetails?.elderMinAge ) ){
              phnMessage = PhoneErrorMessages.restricted;
            }
            setAlert({
              open: true,
              message: phnMessage, 
              type: WARNING,
              confirmText: "okay",
              onConfirm: () => {},
            });
          }
          else if(typeof status === 'string' && status.includes("Email"))
          {
            setLoading(false);
            setAlert({
              open: true,
              message: status,
              type: WARNING,
              confirmText: "okay",
              onConfirm: () => {},
            });
          } 
          else{
          navigate("/myspace/programs", {
            replace: true,
            state: {
              showToast: true,
              toasttitle: "Draft saved!",
              toastmessage: "Finish the form to complete your registration.",
              iconGreen: true,
              toastType: SUCCESS,
            },
          });
        }
          return;
        }
      })
      .catch((error) => {
        console.error("Error submitting form data:", error);
        return;
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if(phoneNumberSend !== ""){
    setRegistrationCountryCode(phoneNumberSend);
    }
  },[phoneNumberSend])

  const displayData = (pqm: ProgramQuestionMap) => {
    const { question } = pqm;
    let value =
      formData && formData[currentSectionIndex]
        ? formData[currentSectionIndex][question.id] || ""
        : "";
    if(value==="") return;
    if( question.type == "tel") {
    const _existingPhone = parsePhoneNumberFromString(value)?.countryCallingCode;
    // setPhoneNumberSend(_existingPhone);
    if(_existingPhone !== phoneNumberSend && _existingPhone !== undefined){
      setPhoneNumberSend(_existingPhone || "");
    }
  }
    if (question.type == "apicall") {
      value =
        pqm.question.questionOptionMaps.filter(
          (optionMap) => optionMap.option.id == value,
        )[0].option.name || "";
    }
      let dragDropDisplay = "";
  if (question.type === "draganddrop") {
    try {
      const decoded = typeof value === "string" ? decodeURIComponent(value) : value;
      const pref = typeof decoded === "string" ? JSON.parse(decoded) : decoded;
      const arr = Array.isArray(pref) ? pref : [];
      dragDropDisplay =
        arr.length === 0
          ? "Any HDB/MSD"
          : [...arr]
              .sort((a, b) => (a?.priorityOrder ?? 0) - (b?.priorityOrder ?? 0))
              .map((s: any) =>
                s?.sessionName && s.sessionName !== "" ? s.sessionName : String(s?.sessionId ?? ""),
              )
              .join(", ");
    } catch (e) {
      dragDropDisplay = typeof value === "string" ? value : "";
    }
  }
    return (
      <div key={question.id} className={styles.fieldGroup}>
        <label className={styles.prefilledfieldLabel}>{question.label}</label>
        {question.type != "file" ? (
          <p className={styles.prefilledfieldValue}>
            {question.type == "draganddrop" ? dragDropDisplay : ""}
            {(question.type == "date" || question.type == "dateandtime") &&
              formateDate(value)}
            {value === false && "No"}
            {value === true && "Yes"}
            {value !== true &&
            question.type !== "dateandtime" &&
            question.type !== "date" &&
            question.type !== "draganddrop" &&
            value !== false
              ? value
              : ""}
          </p>
        ) : question.config.filetype === "video" ? (
          <div className={styles.videoContainer}>
            <video
              src={value}
              controls
              className={styles.videoPlayer}
              data-testid={value}
            ></video>
          </div>
        ) : (
          <div className={styles.fileContainer}>
            <Avatar
              src={value}
              sx={{
                width: 60,
                height: 60,
                borderRadius: "20%",
                "@media (max-width: 780px)": {
                  width: 42,
                  height: 42,
                },
              }}
              data-testid={value}
            />
          </div>
        )}
      </div>
    );
  };

  const handleEditPayment = async () => {
      setCurrentStep("form");
      setCurrentSectionIndex(2);
      setEditMode(true);

      if(userStatus!=null && userStatus?.paymentDetails[0]?.paymentStatus == OFFLINE_PENDING && userStatus?.paymentDetails?.[0]?.editRequests?.[0]?.requestStatus == REQUESTED){
        if(searchParams.get("editpayment") == "" || searchParams.get("editpayment") == null || searchParams.get("editpayment") == undefined) {
        searchParams.set("editpayment", "true");
        setSearchParams(searchParams);
      }
    }
  };

  const handleEditRegistration = async () => {
    refetch();
    if (editMode === true) {
      setEditMode(false);
    }
    if (formData && formData[1]) {
    const trimmedFormData = { ...formData };
    Object.keys(trimmedFormData[1]).forEach(key => {
      const questionId = Number(key);
      const question = programDetails?.programQuestionMaps.find(pqm => pqm.question.id === questionId)?.question;
      if (question && ["text", "email", "textarea", "Address"].includes(question.type)) {
        trimmedFormData[1][key] = trimFormValue(trimmedFormData[1][key].toString());
      }
    });
    setFormData(trimmedFormData);
  }
    setLoading(true);
    const status = await getRegistrationStatus(userStatus?.id || 0);
     if(userIdParam != null && userIdParam != seekerDetails.id){
            setAlert({
              open: true,
              message: WARNING_MESSAGES.NOT_AUTHORIZED,
              type: WARNING,
              confirmText: "logout",
              onConfirm: async () => {
                try{
                  await logoutApi();
                } catch (e){
                }
                localStorage.clear();
                sessionStorage.clear();
                setAlert({ message: [], open: false, type: "" });
                navigate("/", { replace: true });
              },
              // cancelText: "cancel",
            });
           
    } else if (status.approvalStatus === PENDING || status.approvalStatus == null || status.approvalStatus === REJECTED || status.approvalStatus === ON_HOLD) {
      setCurrentStep("form");
      setEditRegistration(true);
      // setEditMode(true);
      setCurrentSectionIndex(1);
      setCompletedSections(new Set());
      if(searchParams.get("isEdit") == "" || searchParams.get("isEdit") == null || searchParams.get("isEdit") == undefined) {
        searchParams.set("isEdit", "true");
        setSearchParams(searchParams);
      }
    } else {
      let message;
      if (status.approvalStatus === REJECTED) {
        message = WARNING_MESSAGES.REJECTED;
      } else if (status.approvalStatus === ON_HOLD) {
        message = WARNING_MESSAGES.REJECTED;
      } else if (status.approvalStatus === APPROVED && !status.paymentStatus?.includes(COMPLETED) && status.paymentStatus != OFFLINE_PENDING) {
        message = WARNING_MESSAGES.ALREADY_BLESSED;
      } 
      if(message){
       setAlert({
        open: true,
        message: message,
        type: WARNING,
        confirmText: "okay",
        onConfirm: () => {
          setAlert({ message: [], open: false, type: "" });
          navigate("/myspace/programs", { replace: true });
        }
      });
    }
    }
    setLoading(false);
  };
  const handleEditData = () => {
    setShowAdditionalInfo(true);
    setshowSuccess(false);
    setCurrentStep("form");
    setCurrentSectionIndex(3);
  };

  // Helper to pre-fill form fields from extract-details API response
  const prefillFormFromExtractedDetails = (
    apiData: any,
    sectionIndex: number,
    questions: any[],
  ) => {
    if (
      !apiData ||
      !apiData.data ||
      !apiData.data.data ||
      !apiData.data.data.data
    )
      return;
    const { tripType, segments } = apiData.data.data.data;
    if (!segments || !Array.isArray(segments) || segments.length === 0) return;
    // Build a map of bindingKey to questionId
    const bindingKeyToQuestionId: Record<string, number> = {};
    questions.forEach((pqm: any) => {
      if (pqm.question && pqm.question.bindingKey) {
        bindingKeyToQuestionId[pqm.question.bindingKey] = pqm.question.id;
      }
    });
    let newFormData = { ...formData };
    if (tripType === "one-way") {
      // Use only the first segment
      const segment = segments[0];
      Object.keys(segment).forEach((key) => {
        if (bindingKeyToQuestionId[key]) {
          if (!newFormData[sectionIndex]) newFormData[sectionIndex] = {};
          newFormData[sectionIndex][bindingKeyToQuestionId[key]] = segment[key];
        }
      });
    } else if (tripType === "round-trip") {
      // Use only the first onward and first return segment
      const onwardSeg = segments.find((seg) => seg.type === "onward");
      const returnSeg = segments.find((seg) => seg.type === "return");
      if (onwardSeg) {
        Object.keys(onwardSeg).forEach((key) => {
          if (bindingKeyToQuestionId[key]) {
            if (!newFormData[sectionIndex]) newFormData[sectionIndex] = {};
            newFormData[sectionIndex][bindingKeyToQuestionId[key]] =
              key.includes("Date") ? new Date(onwardSeg[key]) : onwardSeg[key];
          }
        });
      }
      if (returnSeg) {
        Object.keys(returnSeg).forEach((key) => {
          if (bindingKeyToQuestionId[key]) {
            if (!newFormData[sectionIndex]) newFormData[sectionIndex] = {};
            newFormData[sectionIndex][bindingKeyToQuestionId[key]] =
              key.includes("Date") ? new Date(returnSeg[key]) : returnSeg[key];
          }
        });
      }
    }
    setFormData(newFormData);
  };

  const renderForm = () => {
    if (!groupedQuestions || !programDetails) return null;
    // const sections = groupedQuestions && Object.values(groupedQuestions);
    // const currentSection = sections && sections[currentSectionIndex - 1];

    const sections =
      localGroupedQuestions && Object.values(localGroupedQuestions);
    const currentSection = sections && sections[currentSectionIndex - 1];
    const bannerImageUrl = programDetails?.bannerImageUrl || "";
    const bannerAnimationUrl = programDetails?.bannerAnimationUrl || "";
    // const programDetails = getAllocatedProgramData(userStatus) || null
    //   const { finalValue, inputValues } = getInputValues(userStatus, formData[currentSectionIndex] || {});

    const allocatedProgram = getAllocatedProgramData(userStatus) || null;
    const { finalValue, inputValues } = getInputValues(
      allocatedProgram,
      formData[currentSectionIndex] || {},
      false,
      bindingKeyHashMap,
    );

    return (
      <>  
      <div className={styles.formWrapperContainer}>
        <div className={styles.formContainer}>
          <div className={styles.formWrapper}>
            {currentSection && (
              <div
                className={
                  currentSectionIndex !== 2
                    ? styles.formSectionContainer
                    : styles.formContainerLeftAlign
                }
              >
                <div className={styles.formSection}>
                  <Breadcrumb items={breadcrumbItems} paddingProp={true} />
                  <div className={styles.sectionHeader}>
                    <RegistrationHeader bannerAnimationUrl= {bannerAnimationUrl} bannerImageUrl={bannerImageUrl} />
                    {/* <h2 className={styles.sectionTitle}>Hi {groupedAnswersData?.name || "" }! Let's ensure your profile reflects you fully.</h2> */}
                    {!editMode && currentSection.hasData.length > 0 ? (
                      <>
                        {!editMode && (
                          <>
                            <div className={styles.sectionHeaderText}>
                              <span className={styles.sectionTitle}>
                                Review the details and update if required
                                <span
                                  className={styles.edit}
                                  onClick={handleEdit}
                                >
                                  update details
                                </span>
                              </span>
                            </div>
                            <div
                              className={
                                true
                                  ? styles.fieldsContainer
                                  : styles.fieldsContainerColumn
                              }
                            >
                              {currentSection.hasData.map(
                                (pqm) =>
                                  formData &&
                                  formData[currentSectionIndex] &&
                                  displayData(pqm),
                              )}
                            </div>
                          </>
                        )}
                        {/* </div> */}
                      </>
                    ) : (
                      <>
                        <div className={styles.sectionHeaderEdit}>
                          <div className={styles.sectionHeaderTitleEdit}>
                            {
                              editMode ? (
                                <p className={styles.sectionTitle}>
                                  Update {groupedAnswersData?.name || ""}{" "}
                                  details
                                </p>
                              ) : (
                                ""
                              )
                              //  (
                              //   currentSectionIndex !== 2 && (
                              //     <p className={styles.sectionTitle}>
                              //       Hi {groupedAnswersData?.name || ""}! Let's
                              //       ensure your profile reflects you fully.
                              //     </p>
                              //   )
                              // )
                            }
                          </div>
                          <div
                            className={
                              false
                                ? styles.editfieldsgridContainer
                                : styles.editfieldsColumnColumn
                            }
                          >
                            {programDetails &&
                              currentSection.questions.map((pqm) => (
                                <>
                                  <RenderField
                                    data-question-id={pqm.question.id}
                                    ref={(el) => {
                                      fieldRefs.current[pqm.question.id] = el;
                                    }}
                                    addedclassName={"renderformdragdrop"}
                                    pqm={pqm}
                                    fieldChange = {fieldChange}
                                    formData={
                                      formData && formData[currentSectionIndex]
                                        ? formData[currentSectionIndex]
                                        : {}
                                    }
                                    errors={errors}
                                    handleFieldChange={handleFieldChange}
                                    programDetails={programDetails}
                                    setFormData={setFormData}
                                    totalData={formData}
                                    basePrice={basePrice}
                                    userStatus={userStatus}
                                    handleFieldBlur={handleFieldBlur}
                                    showAlert={showAlert}
                                    bindingKeyHashMap = {bindingKeyHashMap}
                                    defaultgroupedAnswersData = {groupedAnswersData ? groupedAnswersData[currentSectionIndex] : null}
                                    handleLoader = {isShowContent}
                                    setModalDisplay = {setisShowContent}
                                    saveFormData={saveFormData}
                                    setErrors={setErrors}
                                    setRegistrationCountryCode = {setRegistrationCountryCode}
                                    setIsSubmit={setIsSubmit}
                                    isSubmit={isSubmit}
                                  />
                                </>
                              ))}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  {!editMode &&
                    currentSection.hasData.length > 0 &&
                    currentSection.needData.length > 0 &&
                    isDependentCleared(currentSection.needData, bindingKeyHashMap, formData[currentSectionIndex]) &&
                    (
                      <div className={styles.EditsectionHeader}>
                        {/* {currentSection.needData[0]?.question.label} */}
                        <div
                          className={
                            false
                              ? styles.editfieldsgridContainer
                              : styles.editfieldsColumnColumn
                          }
                        >
                          {programDetails &&
                            currentSection.needData.map((pqm) => (
                              <>
                                <RenderField
                                  ref={(el) => {
                                    fieldRefs.current[pqm.question.id] = el;
                                  }}
                                  addedclassName={"renderformdragdrop"}
                                  pqm={pqm}
                                  fieldChange = {fieldChange}
                                  formData={
                                    formData
                                      ? formData[currentSectionIndex]
                                      : {}
                                  }
                                  errors={errors}
                                  handleFieldChange={handleFieldChange}
                                  programDetails={programDetails}
                                  setFormData={setFormData}
                                  totalData={formData}
                                  basePrice={basePrice || 0}
                                  userStatus={userStatus}
                                  handleFieldBlur={handleFieldBlur}
                                  showAlert={showAlert}
                                  bindingKeyHashMap = {bindingKeyHashMap}
                                defaultgroupedAnswersData = {groupedAnswersData ? groupedAnswersData[currentSectionIndex] : null}
                                handleLoader = {isShowContent}
                                setModalDisplay = {setisShowContent}
                                saveFormData={saveFormData}
                                setRegistrationCountryCode = {setRegistrationCountryCode}
                                />
                              </>
                            ))}
                        </div>
                      </div>
                    )}

                  {currentSection.subSection.length > 0 && (
                    <div className={styles.EditsectionHeader}>
                      <div
                        className={
                          false
                            ? styles.editfieldsgridContainer
                            : styles.editfieldsColumnColumn
                        }
                      >
                        <p className={styles.mahatriaTitle}>
                          {/* <span className={styles.highlight}>Mahatria</span>'s{" "} */}
                          More about you:
                        </p>
                        {programDetails &&
                          currentSection.subSection.map((pqm) => (
                         <>
                              <RenderField
                                ref={(el) => {
                                  fieldRefs.current[pqm.question.id] = el;
                                }}
                                addedclassName={"renderformdragdrop"}
                                pqm={pqm}
                                formData={
                                  formData ? formData[currentSectionIndex] : {}
                                }
                                fieldChange = {fieldChange}
                                errors={errors}
                                handleFieldChange={handleFieldChange}
                                programDetails={programDetails}
                                setFormData={setFormData}
                                totalData={formData}
                                basePrice={basePrice || 0}
                                userStatus={userStatus}
                                handleFieldBlur={handleFieldBlur}
                                showAlert={showAlert}
                                bindingKeyHashMap = {bindingKeyHashMap}
                                defaultgroupedAnswersData = {groupedAnswersData ? groupedAnswersData[currentSectionIndex] : null}
                                handleLoader = {isShowContent}
                                setModalDisplay = {setisShowContent}
                                saveFormData={saveFormData}
                                setRegistrationCountryCode = {setRegistrationCountryCode}
                              />
                            </>
                          ))}
                      </div>
                    </div>
                  )}
                  {isMobile && currentSectionIndex == 2 && (
                    <div ref={paymentCardRef}>
                      <PaymentCard
                        inputsObject={inputValues}
                        finalValue={finalValue}
                      />
                    </div>
                  )}
                  {currentSectionIndex == 2 && !isPaymentCardVisible && (
                    <div className={styles.amountStickyFooter}>
                      <div
                        className={styles.lastLine}
                        onClick={handleShowBillingPopUp}
                      >
                        <div className={styles.billingAmountShowPopUp}>
                          <div className={styles.amountToBe}>
                            Amount to be paid
                          </div>
                          <div className={styles.totalAmountMobile}>
                            <div>{finalValue?.value || "Total Amount"}</div>
                            <img
                              src={dropdownIcon}
                              alt="dropdown icon"
                              loading="lazy"
                            />
                          </div>
                        </div>
                        <GrayLine />
                      </div>
                    </div>
                  )}
                  <div className={styles.formActions}>
                    <button
                      onClick={() => handlePreviousSection()}
                      disabled={loading}
                      className={styles.secondaryButton}
                    >
                      cancel
                    </button>
                    {((currentSectionIndex == 1 &&
                      userStatus?.registrationStatus == SAVE_DRAFT) ||
                      (!userStatus?.registrationStatus &&
                        currentSectionIndex == 1)) && (
                      // (((currentSectionIndex == 3) && (userStatus?.travelInfo?.length === 0)) || ((userStatus?.travelInfo[0]?.travelInfoStatus == SAVE_DRAFT) && currentSectionIndex == 3))) &&
                      <button
                        onClick={() => handleDraft()}
                        disabled={loading}
                        className={styles.secondaryButton}
                      >
                        save as draft
                      </button>
                    )}

                    <Button
                      onClick={() => handleSectionComplete(currentSection)}
                      disable={loading}
                      type="button"
                      buttonClassName={styles.primaryButton}
                      buttonTextClassName={styles.primaryButtonText}
                    >
                      submit
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className={styles.footerContainer}>
            <Footer isHDBOnly = {true}/>
          </div>
        </div>
        {sectionLoader && <Loader type="large" />}
        {currentSectionIndex == 2 && !isMobile && (
          <PaymentCard inputsObject={inputValues} finalValue={finalValue} />
        )}
      </div>
      </>
    );
  };

  const breadcrumbItems = [{ label: programDetails?.name|| "", path: "/myspace/programs" }];
  const isSuccess =
    currentStep === "success" ||
    getSuccessStatus(showSuccess, userStatus, showAdditionalInfo, searchParams.get("editpayment"));
  const isAwaitingApproval = getApprovalStatus(userStatus, editRegistration) && searchParams.get("isEdit") !== "true";

  return (
    <>
      <div
        className={[
          styles.container,
          isSuccess ? styles.success : "",
          isAwaitingApproval ? styles.awaitingApproval : "",
        ].join(" ")}
      >
    {(isAwaitingApproval || isSuccess) && (
        <>
    {/* Desktop video - for screens >= 468px */}
    {!isExtraSmall && (
      <video
        autoPlay
        loop
        muted
        playsInline
        className={styles.backgroundVideo}
        src={require("../../assets/images/animationBanner.mp4")}
      />
    )}
    
    {/* Extra small mobile video - for screens < 468px */}
    {isExtraSmall && (
      <video
        autoPlay
        loop
        muted
        playsInline
        className={styles.backgroundVideo}
        src={require("../../assets/images/animationBannerMobile.mp4")}
        // or use a different video file optimized for very small screens
      />
    )}
  </>
      )}
        {/* <Breadcrumb items={breadcrumbItems} paddingProp = {true} /> */}
        {!loading && !handleLoader ? (
          groupedQuestions != null &&
          Object.entries(groupedQuestions).length > 0 ? (
            <div className={styles.mainContainer}>
              {!showSuccess &&
                currentStep == FORM &&
                getFormStatus(
                  userStatus,
                  programDetails,
                  showAdditionalInfo,
                  editRegistration,
                ) &&
                !getSuccessStatus(
                  showSuccess,
                  userStatus,
                  showAdditionalInfo,
                  searchParams.get("editpayment"),
                ) &&
                !isSuccessFlag &&
                renderForm()}
              {(currentStep == "success" ||
                isSuccessFlag ||
                getSuccessStatus(
                  showSuccess,
                  userStatus,
                  showAdditionalInfo,
                  searchParams.get("editpayment"),
                )) && (
                <div>
                  <Breadcrumb items={breadcrumbItems} paddingProp={false} />
                <RegistrationSuccess
                  event={programDetails}
                  personalInfo={userStatus}
                  onBack={() =>
                    navigate("/myspace/programs", { replace: true })
                  }
                  handleEditData={handleEditData}
                  fillAdditionalInfo={programDetails?.type.involvesTravel}
                />
                </div>
              )}
              {getApprovalStatus(userStatus, editRegistration) 
              && searchParams.get("isEdit") !== "true" &&(
                <> 
                <Breadcrumb items={breadcrumbItems} paddingProp={false} />
                <AwaitingApprovalScreen
                  userStatus={userStatus}
                  onEditInfo={handleEditRegistration}
                  onBack={() =>
                    navigate("/myspace/programs", { replace: true })
                  }
                  event={programDetails}
                  editRegistration={editRegistration}
                />
                 </>
              )}
            </div>
          ) : (
            <div className={styles.noDataContainer}>no such program</div>
          )
        ) : (
          <Loader type="large" />
        )}
        {(getApprovalStatus(userStatus, editRegistration) ||
          currentStep == "success" ||
          isSuccessFlag ||
          getSuccessStatus(showSuccess, userStatus, showAdditionalInfo, searchParams.get("editpayment"))) && 
          searchParams.get("isEdit") !== "true" &&
          (
          <div className={styles.successFooterContainer}>
            <Footer isHDBOnly = {true}/>
          </div>
        )}
      </div>
      {alert.open && (
        <AlertPopup
          type={alert.type}
          message={alert.message}
          confirmText={alert?.confirmText ? alert.confirmText : ""}
          onConfirm={() => {
             if (alert?.onReupload) {
        alert.onReupload();
      } else if (alert?.onConfirm) {
        alert.onConfirm();
      }
      setAlert({ message: [], open: false, type: "" });
    }}
          cancelText={alert?.cancelText ? alert.cancelText : undefined}
          onCancel={() => {
            alert?.onCancel && alert.onCancel();
            setAlert({ message: [], open: false, type: "" });
          }}
        />
      )}
    </>
  );
};

export default DynamicForm;

// Update UploadSlot to use className instead of style
export const UploadSlot = ({
  label,
  uploadedFile,
  onFileChange,
}: {
  label: string;
  uploadedFile: File | null;
  onFileChange: (file: File) => void;
}) => {
  const [dragActive, setDragActive] = useState(false);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files && e.target.files[0];
    if (file) {
      onFileChange(file);
    }
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(true);
  };
  const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
  };
  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      onFileChange(e.dataTransfer.files[0]);
    }
  };

  // Render thumbnail for images, icon for PDF
  const renderPreview = () => {
    if (!uploadedFile) return null;
    if (
      uploadedFile.includes("png") ||
      uploadedFile.includes("jpeg") ||
      uploadedFile.includes("jpg") ||
      uploadedFile.includes("webp")
    ) {
      return (
        <img src={uploadedFile} alt="uploaded" className={styles.thumbnail} />
      );
    } else if (uploadedFile.includes("pdf")) {
      return (
        <span
          className={styles.thumbnail}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "2rem",
            background: "#f3f4f6",
          }}
        >
          📄
        </span>
      );
    } else {
      return null;
    }
  };

  return (
    <div className={styles.uploadBox}>
      <label className={styles.uploadLabel}>{label}</label>
      {uploadedFile ? (
        <div className={styles.uploadedPreview}>
          {renderPreview()}
          <div>
            <div className={styles.fileName}>{uploadedFile.name}</div>
            <div>
              <span
                className={styles.reuploadLabel}
                onClick={() => document.getElementById(label)?.click()}
              >
                re-upload file
              </span>
              <input
                type="file"
                accept="image/*,.pdf"
                id={label}
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
            </div>
          </div>
        </div>
      ) : (
        <div
          className={
            dragActive
              ? `${styles.dropArea} ${styles.dragActive}`
              : styles.dropArea
          }
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
        >
          <p className={styles.dragDropLabel}>
            Drag and drop or{" "}
            <label htmlFor={label} className={styles.uploadLink}>
              upload file here
            </label>
            <input
              type="file"
              accept="image/*,.pdf"
              id={label}
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
          </p>
          <p className={styles.fileTypes}>
            Please upload your picture in (JPEG/PNG/PDF)
          </p>
        </div>
      )}
    </div>
  );
};
